import { useEffect, useState } from "react";
import LoadingPage from "./loadingPage";

const DEFAULT_DELAY = 500;

export default function DelayedLoadingFallback({
  delay = DEFAULT_DELAY,
  fallback = <LoadingPage />,
}) {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const timerId = window.setTimeout(() => {
      setShouldShow(true);
    }, delay);

    return () => {
      window.clearTimeout(timerId);
    };
  }, [delay]);

  return shouldShow ? fallback : null;
}
